/* tslint:disabled */
/* eslint-disable */
/**
 * Guardrails
 * The service allows to get create guardrails, update, delete, add to folder, remove from folder them. Also it allows to list, create, update and delete folders.
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ResponseBody } from 'redux-query'
import {
  Guardrail,
  GuardrailFromJSON,
  GuardrailSummary,
  GuardrailSummaryFromJSON,
  GuardrailToJSON
} from '../models'
import * as runtime from '../runtime'

export interface AddGuardrailIntoFolderRequest {
  guardrailId: string
  folderId: string
}

export interface CreateGuardrailRequest {
  guardrail: Guardrail
}

export interface DeleteGuardrailRequest {
  id: string
}

export interface GetGuardrailRequest {
  id: string
}

export interface GetGuardrailsRequest {
  complianceId?: number
  enabledOnly?: boolean
}

export interface RemoveGuardrailFromFolderRequest {
  guardrailId: string
  folderId: string
}

export interface UpdateGuardrailRequest {
  id: string
  guardrail: Guardrail
}

/**
 * Adds guardrail into folder
 * Add Guardrail into Folder
 */
function addGuardrailIntoFolderQueryConfigRaw<T>(
  requestParameters: AddGuardrailIntoFolderRequest,
  requestConfig: runtime.TypedQueryConfig<T, void> = {}
): runtime.RequestConfig<T> {
  if (
    requestParameters.guardrailId === null ||
    requestParameters.guardrailId === undefined
  ) {
    throw new runtime.RequiredError(
      'guardrailId',
      'Required parameter requestParameters.guardrailId was null or undefined when calling addGuardrailIntoFolderQueryConfig.'
    )
  }

  if (
    requestParameters.folderId === null ||
    requestParameters.folderId === undefined
  ) {
    throw new runtime.RequiredError(
      'folderId',
      'Required parameter requestParameters.folderId was null or undefined when calling addGuardrailIntoFolderQueryConfig.'
    )
  }

  let queryParameters = null

  const headerParameters: runtime.HTTPHeaders = {}

  const { meta = {} } = requestConfig

  const config: runtime.RequestConfig<T> = {
    url: `${
      requestConfig.basePath ?? ''
    }/v2/guardrails/{guardrailId}/folders/{folderId}`
      .replace(
        `{${'guardrailId'}}`,
        encodeURIComponent(String(requestParameters.guardrailId))
      )
      .replace(
        `{${'folderId'}}`,
        encodeURIComponent(String(requestParameters.folderId))
      ),
    meta,
    update: requestConfig.update,
    queryKey: requestConfig.queryKey,
    optimisticUpdate: requestConfig.optimisticUpdate,
    force: requestConfig.force,
    rollback: requestConfig.rollback,
    options: {
      method: 'POST',
      headers: headerParameters
    },
    body: queryParameters
  }

  const { transform: requestTransform } = requestConfig
  if (requestTransform) {
  }

  return config
}

/**
 * Adds guardrail into folder
 * Add Guardrail into Folder
 */
export function addGuardrailIntoFolderQueryConfig<T>(
  requestParameters: AddGuardrailIntoFolderRequest,
  requestConfig?: runtime.TypedQueryConfig<T, void>
): runtime.RequestConfig<T> {
  return addGuardrailIntoFolderQueryConfigRaw(requestParameters, requestConfig)
}

/**
 * Creates guardrail
 * Create guardrail
 */
function createGuardrailQueryConfigRaw<T>(
  requestParameters: CreateGuardrailRequest,
  requestConfig: runtime.TypedQueryConfig<T, Guardrail> = {}
): runtime.RequestConfig<T> {
  if (
    requestParameters.guardrail === null ||
    requestParameters.guardrail === undefined
  ) {
    throw new runtime.RequiredError(
      'guardrail',
      'Required parameter requestParameters.guardrail was null or undefined when calling createGuardrailQueryConfig.'
    )
  }

  let queryParameters = null

  const headerParameters: runtime.HTTPHeaders = {}

  headerParameters['Content-Type'] = 'application/json'

  const { meta = {} } = requestConfig

  const config: runtime.RequestConfig<T> = {
    url: `${requestConfig.basePath ?? ''}/v2/guardrails`,
    meta,
    update: requestConfig.update,
    queryKey: requestConfig.queryKey,
    optimisticUpdate: requestConfig.optimisticUpdate,
    force: requestConfig.force,
    rollback: requestConfig.rollback,
    options: {
      method: 'POST',
      headers: headerParameters
    },
    body: queryParameters || GuardrailToJSON(requestParameters.guardrail)
  }

  const { transform: requestTransform } = requestConfig
  if (requestTransform) {
    config.transform = (body: ResponseBody, text: ResponseBody) =>
      requestTransform(GuardrailFromJSON(body), text)
  }

  return config
}

/**
 * Creates guardrail
 * Create guardrail
 */
export function createGuardrailQueryConfig<T>(
  requestParameters: CreateGuardrailRequest,
  requestConfig?: runtime.TypedQueryConfig<T, Guardrail>
): runtime.RequestConfig<T> {
  return createGuardrailQueryConfigRaw(requestParameters, requestConfig)
}

/**
 * Deletes guardrail.
 * Delete guardrail
 */
function deleteGuardrailQueryConfigRaw<T>(
  requestParameters: DeleteGuardrailRequest,
  requestConfig: runtime.TypedQueryConfig<T, void> = {}
): runtime.RequestConfig<T> {
  if (requestParameters.id === null || requestParameters.id === undefined) {
    throw new runtime.RequiredError(
      'id',
      'Required parameter requestParameters.id was null or undefined when calling deleteGuardrailQueryConfig.'
    )
  }

  let queryParameters = null

  const headerParameters: runtime.HTTPHeaders = {}

  const { meta = {} } = requestConfig

  const config: runtime.RequestConfig<T> = {
    url: `${requestConfig.basePath ?? ''}/v2/guardrails/{id}`.replace(
      `{${'id'}}`,
      encodeURIComponent(String(requestParameters.id))
    ),
    meta,
    update: requestConfig.update,
    queryKey: requestConfig.queryKey,
    optimisticUpdate: requestConfig.optimisticUpdate,
    force: requestConfig.force,
    rollback: requestConfig.rollback,
    options: {
      method: 'DELETE',
      headers: headerParameters
    },
    body: queryParameters
  }

  const { transform: requestTransform } = requestConfig
  if (requestTransform) {
  }

  return config
}

/**
 * Deletes guardrail.
 * Delete guardrail
 */
export function deleteGuardrailQueryConfig<T>(
  requestParameters: DeleteGuardrailRequest,
  requestConfig?: runtime.TypedQueryConfig<T, void>
): runtime.RequestConfig<T> {
  return deleteGuardrailQueryConfigRaw(requestParameters, requestConfig)
}

/**
 * Returns a single guardrail
 * Retrieve a single guardrail
 */
function getGuardrailQueryConfigRaw<T>(
  requestParameters: GetGuardrailRequest,
  requestConfig: runtime.TypedQueryConfig<T, Guardrail> = {}
): runtime.RequestConfig<T> {
  if (requestParameters.id === null || requestParameters.id === undefined) {
    throw new runtime.RequiredError(
      'id',
      'Required parameter requestParameters.id was null or undefined when calling getGuardrailQueryConfig.'
    )
  }

  let queryParameters = null

  const headerParameters: runtime.HTTPHeaders = {}

  const { meta = {} } = requestConfig

  const config: runtime.RequestConfig<T> = {
    url: `${requestConfig.basePath ?? ''}/v2/guardrails/{id}`.replace(
      `{${'id'}}`,
      encodeURIComponent(String(requestParameters.id))
    ),
    meta,
    update: requestConfig.update,
    queryKey: requestConfig.queryKey,
    optimisticUpdate: requestConfig.optimisticUpdate,
    force: requestConfig.force,
    rollback: requestConfig.rollback,
    options: {
      method: 'GET',
      headers: headerParameters
    },
    body: queryParameters
  }

  const { transform: requestTransform } = requestConfig
  if (requestTransform) {
    config.transform = (body: ResponseBody, text: ResponseBody) =>
      requestTransform(GuardrailFromJSON(body), text)
  }

  return config
}

/**
 * Returns a single guardrail
 * Retrieve a single guardrail
 */
export function getGuardrailQueryConfig<T>(
  requestParameters: GetGuardrailRequest,
  requestConfig?: runtime.TypedQueryConfig<T, Guardrail>
): runtime.RequestConfig<T> {
  return getGuardrailQueryConfigRaw(requestParameters, requestConfig)
}

/**
 * Returns list of guardrails
 * Retrieve guardrails list
 */
function getGuardrailsQueryConfigRaw<T>(
  requestParameters: GetGuardrailsRequest,
  requestConfig: runtime.TypedQueryConfig<T, Array<GuardrailSummary>> = {}
): runtime.RequestConfig<T> {
  let queryParameters = null

  queryParameters = {}

  if (requestParameters.complianceId !== undefined) {
    queryParameters['compliance-id'] = requestParameters.complianceId
  }

  if (requestParameters.enabledOnly !== undefined) {
    queryParameters['enabled-only'] = requestParameters.enabledOnly
  }

  const headerParameters: runtime.HTTPHeaders = {}

  const { meta = {} } = requestConfig

  const config: runtime.RequestConfig<T> = {
    url: `${requestConfig.basePath ?? ''}/v2/guardrails`,
    meta,
    update: requestConfig.update,
    queryKey: requestConfig.queryKey,
    optimisticUpdate: requestConfig.optimisticUpdate,
    force: requestConfig.force,
    rollback: requestConfig.rollback,
    options: {
      method: 'GET',
      headers: headerParameters
    },
    body: queryParameters
  }

  const { transform: requestTransform } = requestConfig
  if (requestTransform) {
    config.transform = (body: ResponseBody, text: ResponseBody) =>
      requestTransform(body.map(GuardrailSummaryFromJSON), text)
  }

  return config
}

/**
 * Returns list of guardrails
 * Retrieve guardrails list
 */
export function getGuardrailsQueryConfig<T>(
  requestParameters: GetGuardrailsRequest,
  requestConfig?: runtime.TypedQueryConfig<T, Array<GuardrailSummary>>
): runtime.RequestConfig<T> {
  return getGuardrailsQueryConfigRaw(requestParameters, requestConfig)
}

/**
 * Removes guardrail from folder.
 * Remove Guardrail from Folder
 */
function removeGuardrailFromFolderQueryConfigRaw<T>(
  requestParameters: RemoveGuardrailFromFolderRequest,
  requestConfig: runtime.TypedQueryConfig<T, void> = {}
): runtime.RequestConfig<T> {
  if (
    requestParameters.guardrailId === null ||
    requestParameters.guardrailId === undefined
  ) {
    throw new runtime.RequiredError(
      'guardrailId',
      'Required parameter requestParameters.guardrailId was null or undefined when calling removeGuardrailFromFolderQueryConfig.'
    )
  }

  if (
    requestParameters.folderId === null ||
    requestParameters.folderId === undefined
  ) {
    throw new runtime.RequiredError(
      'folderId',
      'Required parameter requestParameters.folderId was null or undefined when calling removeGuardrailFromFolderQueryConfig.'
    )
  }

  let queryParameters = null

  const headerParameters: runtime.HTTPHeaders = {}

  const { meta = {} } = requestConfig

  const config: runtime.RequestConfig<T> = {
    url: `${
      requestConfig.basePath ?? ''
    }/v2/guardrails/{guardrailId}/folders/{folderId}`
      .replace(
        `{${'guardrailId'}}`,
        encodeURIComponent(String(requestParameters.guardrailId))
      )
      .replace(
        `{${'folderId'}}`,
        encodeURIComponent(String(requestParameters.folderId))
      ),
    meta,
    update: requestConfig.update,
    queryKey: requestConfig.queryKey,
    optimisticUpdate: requestConfig.optimisticUpdate,
    force: requestConfig.force,
    rollback: requestConfig.rollback,
    options: {
      method: 'DELETE',
      headers: headerParameters
    },
    body: queryParameters
  }

  const { transform: requestTransform } = requestConfig
  if (requestTransform) {
  }

  return config
}

/**
 * Removes guardrail from folder.
 * Remove Guardrail from Folder
 */
export function removeGuardrailFromFolderQueryConfig<T>(
  requestParameters: RemoveGuardrailFromFolderRequest,
  requestConfig?: runtime.TypedQueryConfig<T, void>
): runtime.RequestConfig<T> {
  return removeGuardrailFromFolderQueryConfigRaw(
    requestParameters,
    requestConfig
  )
}

/**
 * Updates guardrail.
 * Update guardrail
 */
function updateGuardrailQueryConfigRaw<T>(
  requestParameters: UpdateGuardrailRequest,
  requestConfig: runtime.TypedQueryConfig<T, Guardrail> = {}
): runtime.RequestConfig<T> {
  if (requestParameters.id === null || requestParameters.id === undefined) {
    throw new runtime.RequiredError(
      'id',
      'Required parameter requestParameters.id was null or undefined when calling updateGuardrailQueryConfig.'
    )
  }

  if (
    requestParameters.guardrail === null ||
    requestParameters.guardrail === undefined
  ) {
    throw new runtime.RequiredError(
      'guardrail',
      'Required parameter requestParameters.guardrail was null or undefined when calling updateGuardrailQueryConfig.'
    )
  }

  let queryParameters = null

  const headerParameters: runtime.HTTPHeaders = {}

  headerParameters['Content-Type'] = 'application/json'

  const { meta = {} } = requestConfig

  const config: runtime.RequestConfig<T> = {
    url: `${requestConfig.basePath ?? ''}/v2/guardrails/{id}`.replace(
      `{${'id'}}`,
      encodeURIComponent(String(requestParameters.id))
    ),
    meta,
    update: requestConfig.update,
    queryKey: requestConfig.queryKey,
    optimisticUpdate: requestConfig.optimisticUpdate,
    force: requestConfig.force,
    rollback: requestConfig.rollback,
    options: {
      method: 'PUT',
      headers: headerParameters
    },
    body: queryParameters || GuardrailToJSON(requestParameters.guardrail)
  }

  const { transform: requestTransform } = requestConfig
  if (requestTransform) {
    config.transform = (body: ResponseBody, text: ResponseBody) =>
      requestTransform(GuardrailFromJSON(body), text)
  }

  return config
}

/**
 * Updates guardrail.
 * Update guardrail
 */
export function updateGuardrailQueryConfig<T>(
  requestParameters: UpdateGuardrailRequest,
  requestConfig?: runtime.TypedQueryConfig<T, Guardrail>
): runtime.RequestConfig<T> {
  return updateGuardrailQueryConfigRaw(requestParameters, requestConfig)
}

//Requests

/**
 * Adds guardrail into folder
 * Add Guardrail into Folder
 */

async function addGuardrailIntoFolderRequestRaw(
  requestParameters: AddGuardrailIntoFolderRequest
): Promise<runtime.APIResponse<void>> {
  const { url, options, body } =
    addGuardrailIntoFolderQueryConfigRaw(requestParameters)
  const response: Response = await runtime.makeRequestWrapper({
    body,
    options,
    url
  })

  return runtime.VoidApiResponse(response)
}

/**
 * Adds guardrail into folder
 * Add Guardrail into Folder
 */
export async function addGuardrailIntoFolder(
  requestParameters: AddGuardrailIntoFolderRequest
): Promise<runtime.APIResponse<void>> {
  return await addGuardrailIntoFolderRequestRaw(requestParameters)
}

/**
 * Creates guardrail
 * Create guardrail
 */

async function createGuardrailRequestRaw(
  requestParameters: CreateGuardrailRequest
): Promise<runtime.APIResponse<Guardrail>> {
  const { url, options, body } =
    createGuardrailQueryConfigRaw(requestParameters)
  const response: Response = await runtime.makeRequestWrapper({
    body,
    options,
    url
  })

  return runtime.JSONApiResponse(response, jsonValue =>
    GuardrailFromJSON(jsonValue)
  )
}

/**
 * Creates guardrail
 * Create guardrail
 */
export async function createGuardrail(
  requestParameters: CreateGuardrailRequest
): Promise<runtime.APIResponse<Guardrail>> {
  return await createGuardrailRequestRaw(requestParameters)
}

/**
 * Deletes guardrail.
 * Delete guardrail
 */

async function deleteGuardrailRequestRaw(
  requestParameters: DeleteGuardrailRequest
): Promise<runtime.APIResponse<void>> {
  const { url, options, body } =
    deleteGuardrailQueryConfigRaw(requestParameters)
  const response: Response = await runtime.makeRequestWrapper({
    body,
    options,
    url
  })

  return runtime.VoidApiResponse(response)
}

/**
 * Deletes guardrail.
 * Delete guardrail
 */
export async function deleteGuardrail(
  requestParameters: DeleteGuardrailRequest
): Promise<runtime.APIResponse<void>> {
  return await deleteGuardrailRequestRaw(requestParameters)
}

/**
 * Returns a single guardrail
 * Retrieve a single guardrail
 */

async function getGuardrailRequestRaw(
  requestParameters: GetGuardrailRequest
): Promise<runtime.APIResponse<Guardrail>> {
  const { url, options, body } = getGuardrailQueryConfigRaw(requestParameters)
  const response: Response = await runtime.makeRequestWrapper({
    body,
    options,
    url
  })

  return runtime.JSONApiResponse(response, jsonValue =>
    GuardrailFromJSON(jsonValue)
  )
}

/**
 * Returns a single guardrail
 * Retrieve a single guardrail
 */
export async function getGuardrail(
  requestParameters: GetGuardrailRequest
): Promise<runtime.APIResponse<Guardrail>> {
  return await getGuardrailRequestRaw(requestParameters)
}

/**
 * Returns list of guardrails
 * Retrieve guardrails list
 */

async function getGuardrailsRequestRaw(
  requestParameters: GetGuardrailsRequest
): Promise<runtime.APIResponse<Array<GuardrailSummary>>> {
  const { url, options, body } = getGuardrailsQueryConfigRaw(requestParameters)
  const response: Response = await runtime.makeRequestWrapper({
    body,
    options,
    url
  })

  return runtime.JSONApiResponse(response, jsonValue =>
    jsonValue.map(GuardrailSummaryFromJSON)
  )
}

/**
 * Returns list of guardrails
 * Retrieve guardrails list
 */
export async function getGuardrails(
  requestParameters: GetGuardrailsRequest
): Promise<runtime.APIResponse<Array<GuardrailSummary>>> {
  return await getGuardrailsRequestRaw(requestParameters)
}

/**
 * Removes guardrail from folder.
 * Remove Guardrail from Folder
 */

async function removeGuardrailFromFolderRequestRaw(
  requestParameters: RemoveGuardrailFromFolderRequest
): Promise<runtime.APIResponse<void>> {
  const { url, options, body } =
    removeGuardrailFromFolderQueryConfigRaw(requestParameters)
  const response: Response = await runtime.makeRequestWrapper({
    body,
    options,
    url
  })

  return runtime.VoidApiResponse(response)
}

/**
 * Removes guardrail from folder.
 * Remove Guardrail from Folder
 */
export async function removeGuardrailFromFolder(
  requestParameters: RemoveGuardrailFromFolderRequest
): Promise<runtime.APIResponse<void>> {
  return await removeGuardrailFromFolderRequestRaw(requestParameters)
}

/**
 * Updates guardrail.
 * Update guardrail
 */

async function updateGuardrailRequestRaw(
  requestParameters: UpdateGuardrailRequest
): Promise<runtime.APIResponse<Guardrail>> {
  const { url, options, body } =
    updateGuardrailQueryConfigRaw(requestParameters)
  const response: Response = await runtime.makeRequestWrapper({
    body,
    options,
    url
  })

  return runtime.JSONApiResponse(response, jsonValue =>
    GuardrailFromJSON(jsonValue)
  )
}

/**
 * Updates guardrail.
 * Update guardrail
 */
export async function updateGuardrail(
  requestParameters: UpdateGuardrailRequest
): Promise<runtime.APIResponse<Guardrail>> {
  return await updateGuardrailRequestRaw(requestParameters)
}
